/* eslint-disable @typescript-eslint/naming-convention */
export enum SensitiveSkin {
	敏感肌,
	ときどき敏感肌,
	敏感肌ではない,
}
